import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
export const HomeMealIcon = ({ classObject }) => {
    return React.createElement("img", { className: css(styles.container, classObject), src: "/assets/images/icons/home_meal.svg" });
};
const styles = StyleSheet.create({
    container: {
        width: 22,
        height: 22,
    },
});
